export const userStatusOptions = [
  { label: '作業中', value: '作業中', color: '#1976D2', hoverColor: 'rgba(33, 171, 255, 0.8)' },
  { label: '休憩中', value: '休憩中', color: '#E68A00', hoverColor: 'rgba(255, 184, 77, 0.8)' },
  { label: '忙しい', value: '忙しい', color: '#D32F2F', hoverColor: 'rgba(255, 66, 41, 0.8)' },
];

export const userStatusCustomOption = {
  label: '新しいステータスを入力',
  value: 'custom',
  color: '#355009',
  hoverColor: 'rgba(140, 210, 80, 0.8)',
};

export const allUserStatusOptions = [
  ...userStatusOptions,
  userStatusCustomOption,
];
